export const FIELDMESSAGE = 'required';
export const SUCCESSMESSAGE = 'System successfully saved the information';
export const ERRORMESSAGE = 'should not be empty in ';
export const FORMAT_VALIDATION_ERR =
  'X.XXXXXX should be the format for T-Bill Rate';
export const UNSAVED_CHANGES_STR =
  'There are unsaved changes. Do you want to continue?';
export const FROM_QTR_REQUIRED_ERR = 'From Quarter is Required.';
export const STRT_QTR_REQUIRED_ERR = 'Start Quarter is Required';
export const STRT_QTR_GREATER_THAN_3_ERR =
  'Please enter the start quarter greater than or equal to 3Q2020 on Row';
export const END_QTR_ERR = 'End Quarter cannot be prior to Start Quarter';
export const QUARTER_FORMAT_ERROR =
  "Please enter a valid quarter and year in '#Q##' or '#Q####' format. Example: '1Q98' or '1Q1998'.";
export const BOTH_CODE_ERR =
  'User cannot enter both Spec Thera Code and Generic Code number on Row';
export const GENERIC_ERR =
  'There was an error processing the request. Please retry the transaction.';
export const CANNOT_DEL =
  'Entry cannot be deleted, data has been used in CMS report.';
export const DUP_CODE =
  'You are attempting to duplicate an existing Spec Thera Code/Generic Code Number. Please check the data and try again on Row ';
export const SPEC_OR_GEN_CODE_REQUIRED =
  'Spec thera Code or Generic code number is required on Row ';
